import PasswordResetError from "../components/PasswordResetError/PasswordResetError";
import useNavigation from "../hooks/navigation";

const PasswordResetErrorContainer = () => {
  const navigation = useNavigation();

  return (
    <PasswordResetError
      onBackToLoginClick={() => navigation.goToSignIn()}
      onTryAgainClick={() => navigation.goToPasswordReset()}
    />
  );
};

export default PasswordResetErrorContainer;
